define(function (require, exports) {
    'use strict';

    /**
     * Directive for drawing the customizable checkbox
     */
    exports.metCheckbox = function () {
        return {
            restrict: 'E',
            scope: {
                checked: '=',
                label: '@',
                disabled: '@'
            },
            replace: true,
            link: function (scope, element) {

                if (!scope.checked) {
                    scope.checked = false;
                }

                //the input element inside the directive
                var myInput = element.find('input');

                // Disables the checkbox
                scope.$watch('disabled', function() {
                    if (scope.disabled === 'true') {
                        myInput.attr('disabled', 'true');
                        element.addClass('disabled');
                    }
                    else {
                        myInput.attr('disabled', null);
                        element.removeClass('disabled');
                    }
                });

            },
            template: '<div class="custom-checkbox">' +
            '   <input type="checkbox" data-ng-model="checked">' +
            '   <label>' +
            '       <span><span></span></span>' +
            '       {{label}}' +
            '   </label>' +
            '</div>'
        };
    };

    /**
     * Directive for an indeterminate checkbox
     */
    exports.metIndeterminateCheckbox = function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attrs, ctrl) {

                var childList = attrs.childList;
                var disabled = attrs.disabled;
                var myInput = element.find('input');
                var property = 'checked';

                // Disables the checkbox
                if (disabled) {
                    myInput.attr('disabled', 'true');
                    element.addClass('disabled');
                }

                // Bind the onChange event to update children
                element.bind('change', function () {
                    scope.$apply(function () {
                        var isChecked = myInput.prop('checked');

                        // Set each child's selected property to the checkbox's checked property
                        var children = scope.$eval(childList);
                        for (var i = children.length - 1; i >= 0; i--) {
                            var child = children[i];
                            child[property] = isChecked;
                        }
                    });
                });

                // Watch the children for changes
                scope.$watch(childList, function (newValue) {
                    var hasChecked = false;
                    var hasUnchecked = false;

                    // Loop through the children
                    for (var i = newValue.length - 1; i >= 0; i--) {
                        var child = newValue[i];
                        if (child[property]) {
                            hasChecked = true;
                        } else {
                            hasUnchecked = true;
                        }
                    }

                    // Determine which state to put the checkbox in
                    if (hasChecked && hasUnchecked) {
                        myInput.prop('checked', false);
                        myInput.prop('indeterminate', true);
                        if (ctrl) {
                            ctrl.$setViewValue(false);
                        }
                    } else {
                        myInput.prop('checked', hasChecked);
                        myInput.prop('indeterminate', false);
                        if (ctrl) {
                            ctrl.$setViewValue(hasChecked);
                        }
                    }
                }, true);
            }
        };
    };

});



// WEBPACK FOOTER //
// ./scripts/directives/metCheckbox/metCheckbox.js